module.exports = __webpack_public_path__ + "static/og-image-impressum-e69b2e3284490e53cfb6f2ce01a48b63.png";